<template>
  <div>
    <div class="divAll">
      <div class="dicAllLeft">
        <h4>基本信息</h4>
        <el-form :model="form" :rules="rules" ref="form" label-width="300px">
          <el-form-item label="用户名：" prop="name">
            <el-input
              class="input"
              v-model="form.name"
              placeholder="请输入用户名"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号：" prop="telephone">
            <el-input
              class="input"
              v-model="form.telephone"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证号：" prop="identityId">
            <el-input
              class="input"
              v-model="form.identityId"
              placeholder="请输入身份证号"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码：" prop="psw">
            <el-input
              class="input"
              v-model="form.psw"
              type="password"
              autocomplete="off"
              placeholder="请输入密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码：" prop="checkPsw">
            <el-input
              class="input"
              v-model="form.checkPsw"
              type="password"
              autocomplete="off"
              placeholder="请确认密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="姓名：" prop="userName">
            <el-input
              class="input"
              v-model="form.userName"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户照片：">
            <el-upload
              class="avatar-uploader"
              :action="uploadImgUrl"
              :show-file-list="false"
              :on-success="handleAvatarSuccess"
              :before-upload="beforeAvatarUpload"
              :headers="headers"
              :limit="1"
            >
              <img v-if="form.filePhotograph" :src="form.filePhotograph" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              <div
                slot="tip"
                class="el-upload__tip"
                style="font-size: 14px; color: #f49d1a"
              >
                温馨提示:请上传您的照片
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <button type="button" class="common-btn">
              <router-link to="/registrationPage">返回注册页面</router-link>
            </button>
            <button
              type="button"
              class="common-btn my-btn"
              @click="updateUserInfo('form')"
            >
              保存
            </button>
          </el-form-item>
        </el-form>
      </div>
      <div class="leftDiv">123456789</div>
    </div>
  </div>
</template>
<script>
import "cropperjs/dist/cropper.css";
import request from "@/request";
export default {
  // 数据区
  data() {
    var validatePsw = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        if (this.form.checkPsw !== "") {
          this.$refs.form.validateField("checkPsw");
        }
        callback();
      }
    };
    var validateCheckPsw = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.psw) {
        callback(new Error("两次输入密码不一致！"));
      } else {
        callback();
      }
    };
    return {
      form: {},
      uploadImgUrl: request.uploadFile, // 上传的图片服务器地址
      headers: {
        Authorization: this.$cookies.get(this.$commons.User.Authentication),
      },
      fileType: ["png", "jpg", "jpeg"],
      cutImage: false,
      rules: {
        name: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        telephone: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
        identityId: [
          {
            required: true,
            message: "请输入身份证号",
            trigger: "blur",
          },
        ],
        psw: [
          {
            required: true,
            validator: validatePsw,
            trigger: "blur",
          },
        ],
        checkPsw: [
          {
            required: true,
            validator: validateCheckPsw,
            trigger: "blur",
          },
        ],
        userName: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
        ],
      },
    };
  },
  // 页面加载而加载
  created() {},
  // 方法区
  methods: {
    handleAvatarSuccess(res) {
      let _this = this;
      _this.form.filePhotograph = res.data.url;
      _this.$forceUpdate();
      _this.$modal.closeLoading();
    },
    // 上传前loading加载
    beforeAvatarUpload(file) {
      let isImg = false;
      if (this.fileType.length) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
        }
        isImg = this.fileType.some((type) => {
          if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
      } else {
        isImg = file.type.indexOf("image") > -1;
      }

      if (!isImg) {
        this.$modal.msgError(
          `文件格式不正确, 请上传${this.fileType.join("/")}图片格式文件!`
        );
        return false;
      }
      const isLt = file.size / 1024 / 1024 < 5;
      if (!isLt) {
        this.$modal.msgError(`上传头像图片大小不能超过 5MB!`);
        return false;
      }

      this.$modal.loading("正在上传图片，请稍候...");
    },
    loadingImg(event) {
      let _this = this;
      _this.cutImage = true;
      _this.$layer.open({
        title: "图片剪裁",
        type: 1,
        skin: "custom-layer",
        content: $("#cutImage"),
        area: ["680px", "580px"],
        btn: ["确认"],
        success: () => {
          //读取上传文件
          let reader = new FileReader();
          if (event.target.files[0]) {
            //readAsDataURL方法可以将File对象转化为data:URL格式的字符串（base64编码）
            reader.readAsDataURL(event.target.files[0]);
            reader.onload = (e) => {
              let dataURL = reader.result;
              //将img的src改为刚上传的文件的转换格式
              document.querySelector("#cropImg").src = dataURL;
              const image = document.getElementById("cropImg");
              image.onload = () => {
                if (image.width > image.height) {
                  image.style.width = "480px";
                } else {
                  image.style.height = "480px";
                }
                //创建cropper实例
                _this.cropperObj = new Cropper(image, {
                  aspectRatio: 16 / 16,
                  viewMode: 0,
                  minContainerWidth: 480,
                  minContainerHeight: 480,
                  dragMode: "move",
                  preview: [
                    document.querySelector(".previewBox"),
                    document.querySelector(".previewBoxRound"),
                  ],
                });
              };
            };
          }
        },
        yes: (index) => {
          _this.cropperObj
            .getCroppedCanvas({
              maxWidth: 4096,
              maxHeight: 4096,
              fillColor: "#fff",
              imageSmoothingEnabled: true,
              imageSmoothingQuality: "high",
            })
            .toBlob((blob) => {
              //然后调用浏览器原生的toBlob方法将canvas数据转换成blob数据
              //之后就可以愉快的将blob数据发送至后端啦，可根据自己情况进行发送，我这里用的是axios
              const formData = new FormData();
              // 第三个参数为文件名，可选填.
              formData.append("file", blob, "example.png");
              let config = {
                headers: { "Content-Type": "multipart/form-data" },
              };
              axios
                .post(
                  `${request.uploadFile}&Authentication=${_this.$cookies.get(
                    _this.$commons.User.Authentication
                  )}`,
                  formData,
                  config
                )
                .then((response) => {
                  console.log("response------", JSON.stringify(response));
                  if (response.data.errorCode == _this.$commons.RespCode.success) {
                    _this.userInfo.headUrl = response.data.data.path;
                  } else {
                    _this.$layer.alert("图片上传失败");
                  }
                  document.querySelector("#cropImg").src = "";
                  _this.$layer.close(index);
                  _this.cutImage = false;
                })
                .catch((err) => {});
            });
        },
        cancel: (index) => {
          document.querySelector("#cropImg").src = "";
          _this.$layer.close(index);
          _this.cutImage = false;
        },
      });
    },
    // 保存按钮
    updateUserInfo(formName) {
      let _this = this;
      if (!_this.form.name) {
        _this.$layer.alert("请输入用户名");
        return;
      }
      if (_this.form.name.length < 2) {
        _this.$layer.alert("用户名过短");
        return;
      }
      if (!_this.form.telephone) {
        _this.$layer.alert("请输入联系人电话!");
        return;
      } else {
        let myreg = new RegExp(
          "^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$"
        );
        if (!myreg.test(_this.form.telephone)) {
          _this.$layer.alert("联系人电话格式错误!");
          return;
        }
      }
      if (!_this.form.identityId) {
        _this.$layer.alert("请填写身份证号");
        return false;
      } else if (!_this.$util.checkIdCard(_this.form.identityId)) {
        _this.$layer.alert("身份证号不正确");
        return false;
      }
      if (!_this.form.psw) {
        _this.$layer.alert("请填写密码");
        return false;
      } else if (_this.form.psw.length < 6) {
        _this.$layer.alert("密码最少为6位");
        return false;
      }
      if (!_this.form.checkPsw) {
        _this.$layer.alert("请填写重复密码");
        return false;
      }
      if (_this.form.psw != _this.form.checkPsw) {
        _this.$layer.alert("密码与重复密码不一致");
        _this.form.checkPsw = "";
        return false;
      }
      if (!_this.form.userName) {
        _this.$layer.alert("请输入姓名");
        return false;
      } else {
        let nameReg = new RegExp("^[\u4e00-\u9fa5]{0,}$");
        if (!nameReg.test(_this.form.userName)) {
          _this.$layer.alert("姓名格式不正确!");
          return;
        }
      }
      if (!_this.form.filePhotograph) {
        _this.$layer.alert("请上传照片");
        return;
      }
      // _this.$refs[formName].validate((valid) => {
      //   if (valid) {
      //
      let param = {
        // ..._this.form,
        name: _this.form.name,
        specialistPhone: _this.form.telephone,
        identityCard: _this.form.identityId,
        password: _this.form.psw,
        filePhotograph: _this.form.filePhotograph,
        userName: _this.form.userName,
      };
      _this.$api.enterprise
        .specialistRegister(param)
        .then((res) => {
          console.log("res01res02-----", res);
          if (res.code == _this.$commons.RespCode.success) {
            _this.$layer.alert(
              "注册成功!账号和密码为联系人电话",
              { icon: 1, closeBtn: 0 },
              function (index) {
                _this.$layer.close(index);
                _this.$router.push({ name: "login" });
              }
            );
          } else {
            _this.$layer.alert(res.msg);
          }
        })
        .catch(() => {})
        .finally(() => {});
      //   } else {
      //     console.log("error submit!!");
      //     return false;
      //   }
      // });
    },
  },
};
</script>
<style>
h4 {
  color: #4caff8;
  margin-left: 230px;
  margin-bottom: 20px;
}
.el-upload__input {
  display: none !important;
}
.input {
  width: 300px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.common-btn a {
  color: #fff;
  text-decoration: none;
  background-color: #4caff7;
}

.divAll {
  border: 1px solid red;
}
.dicAllLeft {
  width: 800px;
  border: 1px solid lightcoral;
}
.leftDiv {
  font-size: 50px;
  color: burlywood;
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/view/enterprise/specialist.vue